<template>
    <div class="alert alert-info">
        <i class="fa fa-info-circle"></i> You must drop your phone off at the store by the day before the repair.
    </div>
</template>

<script>
export default {
    name: "DropOffDateAlert"
}
</script>

<style scoped>

</style>